import React, { useState } from 'react'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { TextField, useTheme } from '@mui/material'
import moment from 'moment'

const MUIDateTimePicker = ({
    handleChange,
    value,
    minDate = '',
    maxDate = '',
    disabled = false,
    showWarningColor = false,
    label = '',
    fieldProps = {},
    customComponents = {},
    customComponentsProps = {},
    dateTimeFormat = 'L LT',
}) => {
    const [open, setOpen] = useState(false)
    const theme = useTheme()

    return (
        <DateTimePicker
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            value={moment(value)}
            onChange={(e) => {
                handleChange(e)
            }}
            minDateTime={moment(minDate)}
            maxDateTime={moment(maxDate)}
            disabled={disabled}
            timeSteps={{ minutes: 1 }}
            slots={{
                field: TextField,
                ...customComponents,
            }}
            slotProps={{
                field: {
                    onClick: () => {
                        if (disabled) return
                        setOpen((open) => !open)
                    }, // Trigger picker on click
                    onKeyDown: (e) => {
                        if (disabled) return
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault()
                            setOpen((open) => !open)
                        }
                    }, // Trigger picker on Enter or Space
                    label: label,
                    clearable: true,
                    type: 'text',
                    value: value
                        ? moment.utc(value).local().format(dateTimeFormat)
                        : '',
                    InputLabelProps: {
                        shrink: true,
                    },
                    inputProps: {
                        style: {
                            color: showWarningColor
                                ? theme?.palette?.warning?.main
                                : 'black',
                        },
                        readOnly: 'true',
                    },
                    ...fieldProps,
                },
                openPickerButton: {
                    onClick: (e) => {
                        e.preventDefault()
                    },
                    sx: { display: 'none !important' },
                },
                actionBar: {
                    actions: ['clear', 'today'],
                },
                ...customComponentsProps,
            }}
        />
    )
}

export default MUIDateTimePicker
